import { setTrack } from 'Utils/analytics';
import { EventServiceTypes } from './types';

const EventService: EventServiceTypes = {
  userSignInEndEvent: () => {
    setTrack('User Signed In', {});
  },
  userSignOutEvent: () => {
    setTrack('User Signed Out', {});
  },
  userSignUpEvent: (emailUser: string) => {
    setTrack('User Signed Up', {
      email: emailUser,
    });
  },
  userVerifyEmail: () => {
    setTrack('User Verified Email', {});
  },
  userRequestedEmail: () => {
    setTrack('Verification Email Requested', {});
  },
  taxAgencyCredentialUpdate: (taxYear: string | number, method: string) => {
    setTrack('TaxAgency Credential Updated', {
      taxYear,
      method,
    });
  },
  orderStarted: (path: string, productId: string) => {
    setTrack('Order Started', {
      path,
      productId,
    });
  },
  orderCompleted: (productName: string, paymentMethod: string) => {
    setTrack('Order Completed', {
      productName,
      paymentMethod,
    });
  },
  sendButtonPressed: data => {
    setTrack('Button Pressed ', {
      ...data,
      content_category: window.location.pathname,
    });
  },
  formSubmitted: data => {
    setTrack('Form Submitted', {
      ...data,
    });
  },
  taxDataWaitTimeOut: (taxYear, seconds, isPreviousYear, executedAttempts) => {
    setTrack('TaxData Wait TimedOut', {
      taxYear,
      seconds: parseInt((seconds / 1000).toFixed(1), 10),
      isPreviousYear,
      executedAttempts,
    });
  },
  taxDataUserTime: (taxYear, seconds) => {
    setTrack('TaxData User Time', {
      taxYear,
      seconds: parseInt((seconds / 1000).toFixed(1), 10),
    });
  },
  linkClicked: data => {
    setTrack('Link Clicked', {
      ...data,
      content_category: window.location.pathname,
    });
  },
  dataGatheringHelp: data => {
    setTrack('Data Gathering Help', {
      ...data,
    });
  },
  instantRefundSelected: () => {
    setTrack('Instant Refund Selected', {});
  },
  instantRefundFlag: flag => {
    setTrack('Instant Refund Enabled', {
      enabled: flag,
    });
  },
  taxReturnResultView: data => {
    setTrack('TaxReturn Result Viewed', {
      ...data,
    });
  },
  previousYearsResultView: data => {
    setTrack('Previous Years Result Viewed', {
      ...data,
    });
  },
  experimentStarted: (experimentName, flow) => {
    setTrack('Experiment Started', {
      experimentName,
      flow,
    });
  },
  saveCardSessionStarted: () => {
    setTrack('Save Card Session Started', {});
  },
  saveCardSessionCompleted: () => {
    setTrack('Save Card Session Completed', {});
  },
};
export default EventService;
